import { METHOD } from 'services/method'

export const API_MAINTENANCE_PAGE = {
    DETAIL: {
        api: '/v1/dashboard-admin/general-setting/maintenance-page',
        method: METHOD.GET,
    },
    URL_IMAGE_TITLE: {
        api: '/v1/dashboard-admin/general-setting/maintenance-page/storage-url/attachment',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/general-setting/maintenance-page',
        method: METHOD.PUT,
    },
}
